import { render, staticRenderFns } from "./AlertSystemBar.vue?vue&type=template&id=612ca60c"
import script from "./AlertSystemBar.vue?vue&type=script&setup=true&lang=js"
export * from "./AlertSystemBar.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AlertSystemBar.vue?vue&type=style&index=0&id=612ca60c&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('612ca60c')) {
      api.createRecord('612ca60c', component.options)
    } else {
      api.reload('612ca60c', component.options)
    }
    module.hot.accept("./AlertSystemBar.vue?vue&type=template&id=612ca60c", function () {
      api.rerender('612ca60c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/communication/alert/components/AlertSystemBar.vue"
export default component.exports